import type { NormalGatepassFormData } from "@features/gatepass/schema/normalGatepassFormSchema";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface NormalGatepassFormMethods {
  setField<K extends keyof NormalGatepassFormData>(key: K, val: NormalGatepassFormData[K]): void;
  setAll(data: Partial<NormalGatepassFormData>): void;
  resetForm(): void;
}

interface NormalGatepassFormState extends NormalGatepassFormData, NormalGatepassFormMethods {}

const defaultValues: NormalGatepassFormData = {
  SCStatus: "",
  securityClearanceSerial: "",
  securityClearanceId: "",
  securityClearanceValidity: "",
  securityClearanceFott: "",
  gatepassCategory: "NORMAL",
  // Visitor Details
  passportNumber: "",
  emiratesIdNumber: "",
  fullName: "",
  nationality: "",
  passportNumberExpirationDate: "",
  phoneNumber: "",
  sponsorCompany: "",
  expectedEntryDate: "",
  port: "",
  gate: "",
  visitorCompany: "",
  visitorCompanyArabic: "",
  reference: "",
  // Gatepass Details
  gatepassType: "single",
  vip: false,
  requestFor: "entry",
  gatepassDuration: "daily",
  permanentDuration: "1",
  entryType: "",
  FOTTEntry: null,
  isFottDisabled: false,
  // Vehicle Details
  registrationEmirate: "Fujairah",
  vehicleType: "",
  vehicleColour: "",
  category: "",
  plateNumber: "",
  // Locations
  locations: [{ location: "", entryPurpose: "" }],
  groupMembers: [],
  // Photo
  photoUrl: "",
  // Security Clearance ID
};

export const useNormalGatepassFormStore = create<NormalGatepassFormState>()(
  persist(
    (set) => ({
      ...defaultValues,
      setField: (key, val) => set((s) => ({ ...s, [key]: val })),
      setAll: (data) => set((s) => ({ ...s, ...data })),
      resetForm: () => set(() => ({ ...defaultValues })),
    }),
    { name: "normal-gatepass-form" },
  ),
);
